import React, { useEffect, useState } from "react";
import axiosInstance from "../components/api/axiosInstance";

function CustomerChangePassword() {
  const [hasPassword, setHasPassword] = useState(false);
  const [loading, setLoading] = useState(true);
  const [pw, setPw] = useState({ current_password: "", new_password: "", confirm: "" });
  const [savingPw, setSavingPw] = useState(false);
  const [pwMsg, setPwMsg] = useState({ type: "", text: "" });

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await axiosInstance.get("/client/me");
        if (!active) return;
        setHasPassword(!!res.data?.data?.Has_Password);
      } catch (_) {
        if (active) setPwMsg({ type: "error", text: "Could not load account details." });
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  const savePassword = async (e) => {
    e.preventDefault();
    setPwMsg({ type: "", text: "" });
    if ((pw.new_password || "").length < 6) {
      setPwMsg({ type: "error", text: "New password must be at least 6 characters." });
      return;
    }
    if (pw.new_password !== pw.confirm) {
      setPwMsg({ type: "error", text: "Passwords do not match." });
      return;
    }
    setSavingPw(true);
    try {
      await axiosInstance.post("/client/set-password", {
        current_password: pw.current_password || undefined,
        new_password: pw.new_password,
      });
      setPwMsg({ type: "success", text: "Password updated." });
      setHasPassword(true);
      setPw({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      setPwMsg({ type: "error", text: err.response?.data?.message || "Could not update password." });
    } finally {
      setSavingPw(false);
    }
  };

  if (loading) {
    return <p className="cportal-muted">Loading…</p>;
  }

  return (
    <form className="cportal-card" onSubmit={savePassword}>
      <div className="cportal-card-head">
        <h2>{hasPassword ? "Change password" : "Set a password"}</h2>
      </div>
      <p className="cportal-muted">
        {hasPassword
          ? "Update the password you use to log in."
          : "You currently log in with an email code. Set a password to also log in with it."}
      </p>
      {pwMsg.text && (
        <div className={`cportal-alert cportal-alert-${pwMsg.type === "error" ? "error" : "success"}`}>
          {pwMsg.text}
        </div>
      )}

      <div className="cportal-form-grid">
        {hasPassword && (
          <div className="cportal-field">
            <label>Current password</label>
            <input
              type="password"
              value={pw.current_password}
              onChange={(e) => setPw((p) => ({ ...p, current_password: e.target.value }))}
            />
          </div>
        )}
        <div className="cportal-field">
          <label>New password</label>
          <input
            type="password"
            value={pw.new_password}
            onChange={(e) => setPw((p) => ({ ...p, new_password: e.target.value }))}
          />
        </div>
        <div className="cportal-field">
          <label>Confirm new password</label>
          <input
            type="password"
            value={pw.confirm}
            onChange={(e) => setPw((p) => ({ ...p, confirm: e.target.value }))}
          />
        </div>
      </div>

      <div className="cportal-form-actions">
        <button type="submit" className="cportal-btn cportal-btn-primary" disabled={savingPw}>
          {savingPw ? "Saving…" : hasPassword ? "Change password" : "Set password"}
        </button>
      </div>
    </form>
  );
}

export default CustomerChangePassword;
